<div class="gcc-datepicker form-control clickable d-flex align-items-center" [ngClass]="{ open: picker?.isOpen }">
  @switch (empty) {
    @case (true) {
      <span class="flex-grow-1 note text-gray">{{ placeholder }}</span>
    }
    @case (false) {
      <span class="flex-grow-1 note">{{ viewValue }}</span>
    }
  }
  <i class="icon icon-calender text-gray"></i>
</div>
